import {
    IonCol,
    IonInput,
    IonItem,
    IonLabel,
    IonRow,
    IonToggle,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { PrizeMoneyTiers } from "../../models";
import { Table } from "reactstrap";
import RequiredInputIndicator from "../Forms/RequiredInputIndicator";

interface _Props {
    tiers?: (PrizeMoneyTiers | null)
    totalPot?: (number | null)
    isEditable?: (Boolean | null)
    onSubmit?: (Function | null)
}

const PrizeMoneyFixedTable: React.FC<_Props> = ({tiers, isEditable, onSubmit}) => {

    const [totalPot, setTotalPot] = useState(100);
    const [viewThroughTwelve, setViewThroughTwelve] = useState(false);
    const [viewChampion, setViewChampion] = useState(false);
    const [first, setFirst] = useState(30);
    const [second, setSecond] = useState(22);
    const [third, setThird] = useState(15);
    const [fourth, setFourth] = useState(12);
    const [fifth, setFifth] = useState(11);
    const [sixth, setSixth] = useState(10);
    const [seventh, setSeventh] = useState(0);
    const [eighth, setEighth] = useState(0);
    const [ninth, setNinth] = useState(0);
    const [tenth, setTenth] = useState(0);
    const [eleventh, setEleventh] = useState(0);
    const [twelfth, setTwelfth] = useState(0);
    const [champion, setChampion] = useState(0);
    const [reserve, setReserve] = useState(0);

    useEffect(() => {
        if (tiers) {
            if ((tiers && tiers.first)) setFirst(parseFloat(tiers.first));
            if ((tiers && tiers.second)) setSecond(parseFloat(tiers.second));
            if ((tiers && tiers.third)) setThird(parseFloat(tiers.third));
            if ((tiers && tiers.fourth)) setFourth(parseFloat(tiers.fourth));
            if ((tiers && tiers.fifth)) setFifth(parseFloat(tiers.fifth));
            if ((tiers && tiers.sixth)) setSixth(parseFloat(tiers.sixth));
            if ((tiers && tiers.seventh)) setSeventh(parseFloat(tiers.seventh));
            if ((tiers && tiers.eighth)) setEighth(parseFloat(tiers.eighth));
            if ((tiers && tiers.ninth)) setNinth(parseFloat(tiers.ninth));
            if ((tiers && tiers.tenth)) setTenth(parseFloat(tiers.tenth));
            if ((tiers && tiers.eleventh)) setEleventh(parseFloat(tiers.eleventh));
            if ((tiers && tiers.twelfth)) setTwelfth(parseFloat(tiers.twelfth));
            if ((tiers && tiers.champion)) setChampion(parseFloat(tiers.champion));
            if ((tiers && tiers.reserve)) setReserve(parseFloat(tiers.reserve));
            if ((tiers && tiers.seventh)) setViewThroughTwelve(true);
        }
        if (totalPot) {
            setTotalPot(totalPot);
        }
    }, [totalPot, tiers]);

    const calulateSum = () => {
        const sum = first + second + third + fourth + fifth + sixth + seventh + eighth + ninth + tenth + eleventh + twelfth + champion + reserve;
        return sum;
    }

    return (
        <>
            {isEditable && (
                <>
                    <IonRow>
                        <IonCol>
                            <IonItem color="white">
                                <IonLabel>Display 7-12</IonLabel>
                                <IonToggle color="tertiary" slot="end" checked={viewThroughTwelve} onIonChange={e => setViewThroughTwelve(e.detail.checked)} />
                            </IonItem>   
                        </IonCol>
                    </IonRow>
                    {/* <IonRow>
                        <IonCol>
                            <IonItem color="white">
                                <IonLabel>Display Champion and Reserve</IonLabel>
                                <IonToggle color="tertiary" slot="end" checked={viewChampion} onIonChange={e => setViewChampion(e.detail.checked)} />
                            </IonItem>   
                        </IonCol>
                    </IonRow> */}
                    <IonRow>
                        <IonCol>
                            <IonItem color="white">
                                <IonLabel color="danger" position="stacked">Total Amount <RequiredInputIndicator/></IonLabel>
                                <IonInput 
                                    type="number"
                                    value={totalPot}
                                    onIonChange={e => {
                                        if (onSubmit) onSubmit("totalPot", parseFloat(e.detail.value! || "0"));
                                        setTotalPot(parseFloat(e.detail.value! || "0"));
                                    }}
                                />
                            </IonItem>
                        </IonCol>
                    </IonRow>
                </>
            )}
            <IonRow>
                <IonCol>
                    <Table>
                        <thead>
                            <tr>
                                <th>Place</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        {isEditable ?
                            <tbody>
                                <tr>
                                    <th scope="row">1</th>
                                    <th>
                                        <IonInput
                                            type="number"
                                            value={first}
                                            inputmode="numeric"
                                            mode="ios"
                                            min="0"
                                            onIonChange={e => {
                                                setFirst(parseFloat(e.detail.value! || "0"));
                                                if (onSubmit) onSubmit("first", parseFloat(e.detail.value! || "0"));
                                            }}
                                        />
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row">2</th>
                                    <th>
                                        <IonInput
                                            type="number"
                                            value={second}
                                            inputmode="numeric"
                                            min="0"
                                            onIonChange={e => {
                                                setSecond(parseFloat(e.detail.value! || "0"));
                                                if (onSubmit) onSubmit("second", parseFloat(e.detail.value! || "0"));
                                            }}
                                        />
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row">3</th>
                                    <th>
                                        <IonInput
                                            type="number"
                                            value={third}
                                            inputmode="numeric"
                                            min="0"
                                            onIonChange={e => {
                                                setThird(parseFloat(e.detail.value! || "0"));
                                                if (onSubmit) onSubmit("third", parseFloat(e.detail.value! || "0"));
                                            }}
                                        />
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row">4</th>
                                    <th>
                                        <IonInput
                                            type="number"
                                            value={fourth}
                                            inputmode="numeric"
                                            min="0"
                                            onIonChange={e => {
                                                setFourth(parseFloat(e.detail.value! || "0"));
                                                if (onSubmit) onSubmit("fourth", parseFloat(e.detail.value! || "0"));
                                            }}
                                        />
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row">5</th>
                                    <th>
                                        <IonInput
                                            type="number"
                                            value={fifth}
                                            inputmode="numeric"
                                            min="0"
                                            onIonChange={e => {
                                                setFifth(parseFloat(e.detail.value! || "0"));
                                                if (onSubmit) onSubmit("fifth", parseFloat(e.detail.value! || "0"));
                                            }}
                                        />
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row">6</th>
                                    <th>
                                        <IonInput
                                            type="number"
                                            value={sixth}
                                            inputmode="numeric"
                                            min="0"
                                            onIonChange={e => {
                                                setSixth(parseFloat(e.detail.value! || "0"));
                                                if (onSubmit) onSubmit("sixth", parseFloat(e.detail.value! || "0"));
                                            }}
                                        />
                                    </th>
                                </tr>
                                {viewThroughTwelve && (
                                    <>
                                        <tr>
                                            <th scope="row">7</th>
                                            <th>
                                                <IonInput
                                                    type="number"
                                                    value={seventh}
                                                    inputmode="numeric"
                                                    min="0"
                                                    onIonChange={e => {
                                                        setSeventh(parseFloat(e.detail.value! || "0"));
                                                        if (onSubmit) onSubmit("seventh", parseFloat(e.detail.value! || "0"));
                                                    }}
                                                />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="row">8</th>
                                            <th>
                                                <IonInput
                                                    type="number"
                                                    value={eighth}
                                                    inputmode="numeric"
                                                    min="0"
                                                    onIonChange={e => {
                                                        setEighth(parseFloat(e.detail.value! || "0"));
                                                        if (onSubmit) onSubmit("eighth", parseFloat(e.detail.value! || "0"));
                                                    }}
                                                />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="row">9</th>
                                            <th>
                                                <IonInput
                                                    type="number"
                                                    value={ninth}
                                                    inputmode="numeric"
                                                    min="0"
                                                    onIonChange={e => {
                                                        setNinth(parseFloat(e.detail.value! || "0"));
                                                        if (onSubmit) onSubmit("ninth", parseFloat(e.detail.value! || "0"));
                                                    }}
                                                />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="row">10</th>
                                            <th>
                                                <IonInput
                                                    type="number"
                                                    value={tenth}
                                                    inputmode="numeric"
                                                    min="0"
                                                    onIonChange={e => {
                                                        setTenth(parseFloat(e.detail.value! || "0"));
                                                        if (onSubmit) onSubmit("tenth", parseFloat(e.detail.value! || "0"));
                                                    }}
                                                />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="row">11</th>
                                            <th>
                                                <IonInput
                                                    type="number"
                                                    value={eleventh}
                                                    inputmode="numeric"
                                                    min="0"
                                                    onIonChange={e => {
                                                        setEleventh(parseFloat(e.detail.value! || "0"));
                                                        if (onSubmit) onSubmit("eleventh", parseFloat(e.detail.value! || "0"));
                                                    }}
                                                />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="row">12</th>
                                            <th>
                                                <IonInput
                                                    type="number"
                                                    value={twelfth}
                                                    inputmode="numeric"
                                                    min="0"
                                                    onIonChange={e => {
                                                        setTwelfth(parseFloat(e.detail.value! || "0"));
                                                        if (onSubmit) onSubmit("twelfth", parseFloat(e.detail.value! || "0"));
                                                    }}
                                                />
                                            </th>
                                        </tr>
                                    </>
                                )}
                                {viewChampion && (
                                    <>
                                        <tr>
                                            <th scope="row">Champion</th>
                                            <th>
                                                <IonInput
                                                    type="number"
                                                    value={champion}
                                                    min="0"
                                                    onIonChange={e => {
                                                        setChampion(parseFloat(e.detail.value! || "0"))
                                                    }}
                                                />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="row">Reserve</th>
                                            <th>
                                                <IonInput
                                                    type="number"
                                                    value={reserve}
                                                    min="0"
                                                    onIonChange={e => {
                                                        setReserve(parseFloat(e.detail.value! || "0"))
                                                    }}
                                                />
                                            </th>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                            :
                            <tbody>
                                <tr>
                                    <th scope="row">1</th>
                                    <th>{first}</th>
                                </tr>
                                <tr>
                                    <th scope="row">2</th>
                                    <th>{second}</th>
                                </tr>
                                <tr>
                                    <th scope="row">3</th>
                                    <th>{third}</th>
                                </tr>
                                <tr>
                                    <th scope="row">4</th>
                                    <th>{fourth}</th>
                                </tr>
                                <tr>
                                    <th scope="row">5</th>
                                    <th>{fifth}</th>
                                </tr>
                                <tr>
                                    <th scope="row">6</th>
                                    <th>{sixth}</th>
                                </tr>
                                {viewThroughTwelve && (
                                    <>
                                        <tr>
                                            <th scope="row">7</th>
                                            <th>{seventh}</th>
                                        </tr>
                                        <tr>
                                            <th scope="row">8</th>
                                            <th>{eighth}</th>
                                        </tr>
                                        <tr>
                                            <th scope="row">9</th>
                                            <th>{ninth}</th>
                                        </tr>
                                        <tr>
                                            <th scope="row">10</th>
                                            <th>{tenth}</th>
                                        </tr>
                                        <tr>
                                            <th scope="row">11</th>
                                            <th>{eleventh}</th>
                                        </tr>
                                        <tr>
                                            <th scope="row">12</th>
                                            <th>{twelfth}</th>
                                        </tr>
                                    </>
                                )}
                                {viewChampion && (
                                    <>
                                        <tr>
                                            <th scope="row">Champion</th>
                                            <th>{champion}</th>
                                        </tr>
                                        <tr>
                                            <th scope="row">Reserve</th>
                                            <th>{reserve}</th>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        }
                    </Table>
                </IonCol>
            </IonRow>
            {isEditable && (
                <IonRow>
                    <IonCol>
                        Sum of table values: {calulateSum()}
                    </IonCol>
                </IonRow>
            )}
        </>
    );
};

export default PrizeMoneyFixedTable;